<template>
    <div class="settings-dashboard">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Configurações</mu-title>

        <!-- Opções para montagem do menu -->
        <mu-options :options="options"></mu-options>

    </div>
</template>

<script>
    import Menu from '@/config/menu'

    let MenuOptions = Menu.find('settings')

    export default {
        name: 'app-settings-dashboard',
        data () {
            return {
                options: MenuOptions
            }
        }
    }
</script>
